import React from 'react';
import { Container, Box } from '@material-ui/core';
import { useLayoutStyles, LAYOUT_MIN_WIDTH, LAYOUT_MAX_WIDTH } from './Globals';
import clsx from 'clsx';

/**
 * Implements padding and max widths for page content.
 * Usage:
 * ...
 *    <NavBar />
 *    <ContentLayout>
 *    ... children subject to padding and screen widths here
 *    </ContentLayout>
 * ...
 */
export function ContentLayout({ children, containerClassName, customStyles, ...props }) {
    const styles = useLayoutStyles();
    return (
        <Box
            component={Container}
            minWidth={LAYOUT_MIN_WIDTH}
            maxWidth={LAYOUT_MAX_WIDTH}
            className={clsx(styles.contentHorizontalPadding, containerClassName, customStyles)}
            {...props}
        >
            {children}
        </Box>
    );
}
